export const GENERAL_MARKETS_KEYS = {
  primary: 'primary',
  secondary: 'secondary',
  transactions: 'transactions',
};
